module.exports = __webpack_public_path__ + "img/clear-filter.6eee1fd4.png";